module.exports = __webpack_public_path__ + "static/images/live-t1.5dd195c.png";